import { Button, Tooltip } from "antd";
import type { ReactNode } from "react";
import { useIntl } from "react-intl";

type Props = {
  buttonType: "icon" | "button";
  textIntl: string;
  onClick: () => void;
  icon: ReactNode;
};

export const ActionButton = ({ buttonType, icon, textIntl, onClick }: Props) => {
  const { formatMessage } = useIntl();
  return (
    <>
      {buttonType === "button" && (
        <Button onClick={onClick} type={"primary"}>
          {icon}
          {formatMessage({ id: textIntl })}
        </Button>
      )}
      {buttonType === "icon" && (
        <Tooltip placement="topLeft" title={formatMessage({ id: textIntl })} arrow>
          <Button onClick={onClick} type={"text"} icon={icon}></Button>
        </Tooltip>
      )}
    </>
  );
};
